<app-breadcrumb></app-breadcrumb>
<div class="container">
     <div class="disclaimer-container">
          <h1>Legal Disclaimer</h1>
          <p>
              The Pilot Logbook application (hereinafter referred to as "the Application") is provided solely as a tool for individual use. 
              The Allied Pilots Association (APA) does not guarantee the accuracy, completeness, reliability, or 
              timeliness of any data retrieved, entered into, stored within, processed by, or downloaded from the Application.
          </p>
          <p>By using the Application, you acknowledge and agree that:</p>
          <ol>
              <li>The APA bears no responsibility for any errors, omissions, or inaccuracies within the Application, its data, or any data downloaded or exported from the Application.</li>
              <li>The APA is not liable for any decisions, actions, or outcomes resulting from the use of the Application, reliance upon its data, or use of downloaded/exported information.</li>
              <li>The user assumes all risks associated with the use of the Application and any downloaded data, including but not limited to compliance with applicable aviation regulations, company policies, or other professional requirements.</li>
          </ol>
          <p>It remains the sole responsibility of each user to:</p>
          <ul>
              <li>Ensure the accuracy of their logbook entries, both within the Application and any downloaded formats.</li>
              <li>Verify that any downloaded information aligns with regulatory and operational standards before use.</li>
          </ul>
          <p>
              The APA expressly disclaims any and all liability arising from the use or misuse of the Application or its associated data. 
              For authoritative guidance or specific regulatory questions, users are encouraged to consult official sources or qualified professionals.
          </p>
      </div>
</div>